import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {faSearchDollar, faTruck, faTruckLoading, faRandom, faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import {Port} from "../../../../shared/types/models/port.model";
import {Observable, Subject} from "rxjs";
import {Vehicle} from "../../../../shared/types/models/vehicle.model";
import {Job} from "../../../../shared/types/models/job.model";
import {TransportService} from "../../../../shared/types/models/transport-service.model";
import {Options} from "ng5-slider";
import {TransportServiceService} from "../../../../core/services/transport-service/transport-service.service";
import {JobService} from "../../../../core/services/job/job.service";
import {NgxSmartModalService} from "ngx-smart-modal";
import {Router} from "@angular/router";
import {PriceSummaryModalComponent} from "../price-summary-modal/price-summary-modal.component";
import {debounceTime, distinctUntilChanged, filter, map} from "rxjs/operators";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-new-calculator',
  templateUrl: './new-calculator.component.html',
  styleUrls: ['./new-calculator.component.scss'],
  animations: [
    trigger('openClose', [
      // ...
      state('open', style({
        minHeight: '200px'
      })),
      state('closed', style({
        height: '0',
        minHeight: '0'
      })),
      transition('open => closed', [
        animate('0.2s')
      ]),
      transition('closed => open', [
        animate('0.2s')
      ]),
    ]),
  ]
})
export class NewCalculatorComponent implements OnInit {
  faSearchDollar = faSearchDollar;
  faTruckLoading = faTruckLoading;
  faRandom = faRandom;
  faTimesCircle = faTimesCircle;

  loadingPort: Port;
  destinationPort: Port;
  vehicle: Vehicle;

  tempLoadingPort: Port;
  tempDestinationPort: Port;
  tempVehicle: Vehicle;

  job: Job = new Job();

  services: TransportService[];

  loadingPorts: any[] = [];
  destinationPorts: any[] = [];
  vehicles: any[] = [];

  showAdditionalDetails: boolean = false;

  @Input()
  accountId: string;

  constructor(public transportServiceService: TransportServiceService,
              public jobService: JobService,
              public ngxSmartModalService: NgxSmartModalService,
              public router: Router) { }

  ngOnInit() {
    const accountId = 'f2aba69b-355e-4f9a-bab4-a0db6a44e8fc';
    this.job.accountId = accountId;
    this.job.isQuotation = true;
    this.transportServiceService.getRouteListings$(accountId)
      .subscribe(response => {
        this.services = response.body;
        console.log(this.services);

        this.bindPorts();
        this.bindVehicles();
      });
  }

  bindPorts(): void {
    let lps = [];
    let dps = [];

    this.services.forEach(s => {
      lps.push(s.loadingPort);
      dps.push(s.destinationPort);
    });

    this.loadingPorts = lps.filter((lp, index) => {
      const _thing = JSON.stringify(lp);
      return index === lps.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });

    this.loadingPorts = this.loadingPorts.sort((a, b) => (a.name > b.name) ? 1 : -1)

    this.destinationPorts = dps.filter((dp, index) => {
      const _thing = JSON.stringify(dp);
      return index === dps.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });

    this.destinationPorts = this.destinationPorts.sort((a, b) => (a.name > b.name) ? 1 : -1)
  }

  bindVehicles(): void {
    let vs = [];

    this.services.forEach(s => {
      vs.push(s.vehicle);
    });

    this.vehicles = vs.filter((v, index) => {
      const _thing = JSON.stringify(v);
      return index === vs.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });

    this.vehicles = this.vehicles.sort((a, b) => (a.name > b.name) ? 1 : -1)
  }

  loadingPortFormatter = (port: Port) => {
    return port.name + ', ' + port.country.code;
  }

  destinationPortFormatter = (port: Port) => {
    return port.name + ', ' + port.country.code;
  }

  vehicleFormatter = (vehicle: Vehicle) => vehicle.name;

  onFocus(e: Event): void {
    console.log('called');
    e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event('input');
      e.target.dispatchEvent(inputEvent);
    }, 0);
  }

  searchLoading = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => {
      if (this.destinationPort || this.vehicle) {

        let reducedServices = Object.assign([], this.services);

        if (this.destinationPort) {
          reducedServices = this.reducedByDestinationPort(reducedServices, this.destinationPort);
        }

        if (this.vehicle) {
          reducedServices = this.reducedByVehicle(reducedServices, this.vehicle);
        }

        let lps = [];

        reducedServices.forEach(s => {
          lps.push(s.loadingPort);
        });

        const reducedLoading = lps.filter((lp, index) => {
          const _thing = JSON.stringify(lp);
          return index === lps.findIndex(obj => {
            return JSON.stringify(obj) === _thing;
          });
        });

        return term === '' ? reducedLoading : reducedLoading.filter(port => new RegExp(term, 'mi').test(port.name)).slice(0, 10);
      }

      return term === '' ? this.loadingPorts : this.loadingPorts.filter(port => new RegExp(term, 'mi').test(port.name)).slice(0, 10)
    })
  );

  searchDestination = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => {

      if (this.loadingPort || this.vehicle) {

        let reducedServices = Object.assign([], this.services);

        if (this.loadingPort) {
          reducedServices = this.reducedByLoadingPort(reducedServices, this.loadingPort);
        }

        if (this.vehicle) {
          reducedServices = this.reducedByVehicle(reducedServices, this.vehicle);
        }

        let dps = [];

        reducedServices.forEach(s => {
          dps.push(s.destinationPort);
        });

        const reducedDestinations = dps.filter((dp, index) => {
          const _thing = JSON.stringify(dp);
          return index === dps.findIndex(obj => {
            return JSON.stringify(obj) === _thing;
          });
        });

        return term === '' ? reducedDestinations : reducedDestinations.filter(port => new RegExp(term, 'mi').test(port.name)).slice(0, 10);
      }

      return term === '' ? this.destinationPorts : this.destinationPorts.filter(port => new RegExp(term, 'mi').test(port.name)).slice(0, 10);
    })
  );

  searchVehicle = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => {
      if (this.loadingPort || this.destinationPort) {

        let reducedServices = Object.assign([], this.services);

        if (this.loadingPort) {
          reducedServices = this.reducedByLoadingPort(reducedServices, this.loadingPort);
        }

        if (this.destinationPort) {
          reducedServices = this.reducedByDestinationPort(reducedServices, this.destinationPort);
        }

        let vs = [];

        reducedServices.forEach(s => {
          vs.push(s.vehicle);
        });

        const reducedVehicles = vs.filter((v, index) => {
          const _thing = JSON.stringify(v);
          return index === vs.findIndex(obj => {
            return JSON.stringify(obj) === _thing;
          });
        });

        return term === '' ? reducedVehicles : reducedVehicles.filter(vehicle => new RegExp(term, 'mi').test(vehicle.name)).slice(0, 10)
      }

      return term === '' ? this.vehicles : this.vehicles.filter(vehicle => new RegExp(term, 'mi').test(vehicle.name)).slice(0, 10)
    })
  );

  private reducedByLoadingPort(services: TransportService[], port: Port): TransportService[] {
    return services.filter(s => {
      return s.loadingPort.id == port.id;
    });
  }

  private reducedByDestinationPort(services: TransportService[], port: Port): TransportService[] {
    return services.filter(s => {
      return s.destinationPort.id == port.id;
    });
  }

  private reducedByVehicle(services: TransportService[], vehicle: Vehicle): TransportService[] {
    return services.filter(s => {
      return s.vehicle.id == vehicle.id;
    });
  }

  isQuoteDisabled(): boolean {
    if (!this.job.service) {
      return true;
    }

    if (this.job.service.showDimensionCapture) {
      if (this.job.goodsPackage.length == null ||
        this.job.goodsPackage.width == null ||
        this.job.goodsPackage.height == null ||
        this.job.goodsPackage.grossWeight == null) {
        return true;
      }

      if (this.job.service.minLength > this.job.goodsPackage.length ||
        this.job.service.minWidth > this.job.goodsPackage.width ||
        this.job.service.minHeight > this.job.goodsPackage.height) {
        return true;
      }
      if (this.job.service.maxLength != 0 && this.job.service.maxLength < this.job.goodsPackage.length ||
        this.job.service.maxWidth != 0 && this.job.service.maxWidth < this.job.goodsPackage.width ||
        this.job.service.maxHeight != 0 && this.job.service.maxHeight < this.job.goodsPackage.height) {
        return true;
      }

      // calculate cbm and compare against max size
      const cbm = this.job.goodsPackage.length * this.job.goodsPackage.width * this.job.goodsPackage.height;

      if (this.job.service.maxSize != 0 && cbm && cbm > this.job.service.maxSize) {
        return true;
      }
    }

    return false;
  }

  getQuote(): void {
    this.jobService.quotationNumber()
      .subscribe(number => {
        this.job.reference = '' + number;

        this.jobService.create$(this.job)
          .subscribe(job => {
            const modal = this.ngxSmartModalService.create('priceSummaryModal', PriceSummaryModalComponent, { dismissable: false });
            modal.setData({job: job});
            modal.open();
          });
      });
  }

  checkForServiceByLoading(item): void {
    this.checkForService(item.item, this.destinationPort, this.vehicle);
  }

  checkForServiceByDestination(item): void {
    this.checkForService(this.loadingPort, item.item, this.vehicle);
  }

  checkForServiceByVehicle(item): void {
    this.checkForService(this.loadingPort, this.destinationPort, item.item);
  }

  checkForService(loading, destination, vehicle): void {

    if (loading && destination && vehicle) {
      let reducedServices = this.reducedByLoadingPort(this.services, loading);
      reducedServices = this.reducedByDestinationPort(reducedServices, destination);
      reducedServices = this.reducedByVehicle(reducedServices, vehicle);

      const route = reducedServices[0];

      this.transportServiceService.getById$(route.id).subscribe( (response) => {
        console.log(response);
        this.job.service = response;
        this.showAdditionalDetails = this.job && this.job.service && ((this.job.service.showTowed || this.job.service.showTracked || this.job.service.showLoading) || this.job.service.showDimensionCapture);
      });
    } else {
      this.job.service = null;
    }
  }

  clearService(): void {
    this.loadingPort = null;
    this.destinationPort = null;
    this.vehicle = null;

    this.job.service = null;
    this.job.goodsPackage.length = null;
    this.job.goodsPackage.width = null;
    this.job.goodsPackage.height = null;
    this.job.goodsPackage.grossWeight = null;

    this.showAdditionalDetails = false;
  }

  getCubic(): number {
    let cubic = 0;

    if (this.job.goodsPackage.length != null && this.job.goodsPackage.width != null && this.job.goodsPackage.height != null) {
      cubic = this.job.goodsPackage.length * this.job.goodsPackage.width * this.job.goodsPackage.height;
    }

    return cubic;
  }

}
